import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ComponentProps } from "react";

import { installLeaveGuard } from "@/hooks/use-leave-guard";

// 모듈 최상위 — 하이드레이션 렌더 중에 평가돼 Next 라우터의 popstate effect 보다 먼저 등록된다(로그인 뒤 /app 으로 소프트 이동해도 이미 걸려 있다).
installLeaveGuard();

/**
 * next-themes 는 클라이언트 전용이다. 루트 레이아웃(서버)에서 바로 쓸 수 없어
 * 한 겹 감싼다.
 */
const ThemeProvider = ({
  children,
  ...props
}: ComponentProps<typeof NextThemesProvider>) => {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
};

export default ThemeProvider;
